export default "__VITE_ASSET__jCuQRKE9__"